var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLocationPinFill = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M12 2c-4.687 0-8.5 3.813-8.5 8.5 0 4.983 4.577 9.63 7.64 11.652l.53.352a.5.5 0 0 0 .554 0l.53-.352c3.063-2.023 7.744-6.669 7.744-11.652C20.5 5.813 16.687 2 12 2m0 11.5a3 3 0 1 1 0-6 3 3 0 0 1 0 6"
})));
export default SvgLocationPinFill;